module.exports = __webpack_public_path__ + "static/media/esforco1.53a09bd3.png";